import React from 'react'
import "./ProfilField.css"
import Typewriter from "typewriter-effect"

export default function ProfilField() {
    return (
        <div className="ProfilField">
                <img className="pp"  src={"/pp.jpeg"} alt="pp" />
                <div className="text">
                <Typewriter  className="text" 
                             onInit={(typewriter)=>{
                                 typewriter.typeString('selam arkadaşlar ben kaan karakoç')
                                 .pauseFor(1500)
                                 .deleteAll()
                                 .typeString('python,js gibi dillerde kendimi geliştiriyorum.')
                                 .pauseFor(1500)
                                 .deleteAll()
                                 .typeString('Aşağıdan hesaplarıma ulaşabilirsiniz.')
                                 .start()
                             }}
                             options={{delay:40}}
                />
                </div>
        </div>
    )
}
